import axios from "axios";
import store from "./store/auth";

const axiosInstance = axios.create({
baseURL: "https://server.ujpdsfl.cluster024.hosting.ovh.net/",
//baseURL: "http://localhost:8080/",
  headers: {
    "Content-type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const { user, isAuthenticated } = store.getters;

    if (isAuthenticated) {
      config.headers = {
        ...config.headers,
        authorization: user.token,
      };
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export default axiosInstance;
